// Module
var code = "<a href=\"javascript:;\" type=\"button\" class=\"text-sm sps-btn sps-btn-outline btn-color-template dropdown-toggle template-btn disabled\" data-bind=\"style: _style\" data-toggle=\"dropdown\"> <!-- ko text: Label --><!-- /ko --> <i class=\"fa fa-angle-down\"></i> </a>";
// Exports
export default code;